// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1M1lQ94Y","footer":"_3iZj9VMg","content":"_2SgjObyJ"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/Footer/Footer.styl
// module id = 249
// module chunks = 0